import React from "react";
import Button from "../../../../../components/button/button.jsx";
import SelectComponent from "../../../../../components/select/select-component.jsx";
import InputDatetime from "../../../../../components/input/input-datetime.jsx";
import {FaEdit, FaPen, FaTrash} from "react-icons/fa";
import {addressSummary, hoursSummary} from "../utils/schedule-garrison-utils.js";

const INPUT_CLASS = "block w-full px-2.5 py-1 text-sm bg-white border border-[#e5e7eb] rounded-md focus:outline-none focus:border-blue-600 h-[32px]";
const REQUIRED_LABEl_BG = "!bg-[linear-gradient(to_bottom,transparent_50%,#fdfdee_50%)]";

const ScheduleGarrisonActivities = ({activities, reasonOptions, priorityOptions, onRemove, onChange, onEditHours, onEditAddress, REQUIRED_BG}) => (
    <div className="rounded-lg border border-[#D2D3D5] font-[Roboto,sans-serif] text-[#2E3742]">
        <table className="w-full text-sm border-collapse">
            <thead>
                <tr className="bg-[#efefef] text-left border-b border-[#D2D3D5] text-gray-600">
                    <th className="px-2 h-10 font-medium w-[16%]">Horário</th>
                    <th className="px-2 h-10 font-medium w-[12%]">Duração (hh:mm)</th>
                    <th className="px-2 h-10 font-medium w-[16%]">Natureza *</th>
                    <th className="px-2 h-10 font-medium w-[14%]">Prioridade</th>
                    <th className="px-2 h-10 font-medium w-[18%]">Local *</th>
                    <th className="px-2 h-10 font-medium">Descrição</th>
                    <th className="px-2 h-10 w-[50px]"/>
                </tr>
            </thead>
            <tbody>
                {activities.map((activity, index) => {
                    const isLast = index === activities.length - 1;
                    return (
                        <tr
                            key={activity.tempId}
                            className={["align-top", isLast ? "" : "border-b border-[#D2D3D5]"].join(" ")}
                        >
                            <td className="p-2">
                                <div className="flex items-center gap-2">
                                    <span className="flex-1">{hoursSummary(activity.hours)}</span>
                                    <Button title="Editar horário" onClick={() => onEditHours(activity.tempId)}><FaPen /></Button>
                                </div>
                            </td>
                            <td className="p-2">
                                <InputDatetime
                                    label=""
                                    dateFormat="LT"
                                    returnDateObj={false}
                                    selected={activity.duration ?? ""}
                                    onChange={(value) => onChange(activity.tempId, {duration: value ?? ""})}
                                />
                            </td>
                            <td className="p-2">
                                <SelectComponent
                                    options={reasonOptions}
                                    isClearable
                                    classNameWrapper={REQUIRED_BG}
                                    labelClass={REQUIRED_LABEl_BG}
                                    value={reasonOptions.find(option => option.value === activity.reason) ?? null}
                                    onChange={(option) => onChange(activity.tempId, {reason: option?.value ?? ""})}
                                />
                            </td>
                            <td className="p-2">
                                <SelectComponent
                                    options={priorityOptions}
                                    isClearable
                                    classNameWrapper={"bg-white"}
                                    value={priorityOptions.find(option => option.value === activity.priority) ?? null}
                                    onChange={(option) => onChange(activity.tempId, {priority: option?.value ?? ""})}
                                />
                            </td>
                            <td className="p-2">
                                <div className="flex items-center gap-2">
                                    <span className="flex-1">{addressSummary(activity.address)}</span>
                                    <Button title="Editar local" onClick={() => onEditAddress(activity.tempId)}><FaPen /></Button>
                                </div>
                            </td>
                            <td className="p-2">
                                <input
                                    className={INPUT_CLASS}
                                    value={activity.description ?? ""}
                                    onChange={(e) => onChange(activity.tempId, {description: e.target.value})}
                                />
                            </td>
                            <td className="p-2 text-center">
                                <Button target="danger" title="Remover atividade" onClick={() => onRemove(activity.tempId)}><FaTrash/></Button>
                            </td>
                        </tr>
                    );
                })}
                {!activities.length &&
                    <tr><td colSpan={7} className="px-2 h-7.5 text-center content-center">Nenhuma atividade adicionada.</td></tr>
                }
            </tbody>
        </table>
    </div>
);

export default ScheduleGarrisonActivities;
